import type { DataFetchingClient } from 'data-fetching-client';
import { safeGetPortalsLoginVerifyEarlyRequest } from './portalsLoginVerify';

export async function getPortalsLocaleInfo(config: {
  client: DataFetchingClient;
  objectId?: number;
}): Promise<{
  locale: string;
  langEnabled: boolean;
}> {
  const searchParams = new URLSearchParams(window.location.search);
  const localeOverride = searchParams.get('localeOverride');
  if (localeOverride) {
    return { langEnabled: true, locale: localeOverride };
  }
  const loginData = await safeGetPortalsLoginVerifyEarlyRequest({
    objectId: config.objectId,
  });
  if (loginData?.type === 'data') {
    const locale = loginData?.data.preferredLanguage || navigator.language;
    return { langEnabled: true, locale };
  }
  return { langEnabled: true, locale: navigator.language };
}
